// Chave única e criptográfica de assinatura por utilizador.
// Determinística: a mesma conta gera sempre a mesma chave, o que permite
// reconstruir a chave em requerimentos antigos sem guardar segredos extras.

import { unmaskCPF } from '@/utils/masks'

const SAL_ASSINATURA = 'protocoleai-assinatura-v1'

/** Gera a chave curta (ex.: PRT-4A9C-1B77) a partir do utilizador e do CPF. */
export async function gerarChaveAssinatura(userId: string, cpf: string): Promise<string> {
  const base = `${SAL_ASSINATURA}:${userId || 'sem-id'}:${unmaskCPF(cpf || '')}`
  const enc = new TextEncoder().encode(base)
  const buf = await crypto.subtle.digest('SHA-256', enc)
  const hex = Array.from(new Uint8Array(buf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()
  return `PRT-${hex.slice(0, 4)}-${hex.slice(4, 8)}`
}

export interface AssinaturaAutorizador {
  userId: string
  nomeCompleto: string
  funcao: string
  cpf: string
  chave: string
  emitidoEm: string
}

/** Monta o bloco de assinatura do autorizador do requerimento. */
export async function montarAssinatura(usuario: {
  userId?: string
  nomeCompleto?: string
  funcao?: string
  cpf?: string
  chaveAssinatura?: string
} | null): Promise<AssinaturaAutorizador | null> {
  if (!usuario)
    return null
  const chave = usuario.chaveAssinatura || await gerarChaveAssinatura(usuario.userId || '', usuario.cpf || '')
  return {
    userId: usuario.userId || '',
    nomeCompleto: usuario.nomeCompleto || '',
    funcao: usuario.funcao || '',
    cpf: usuario.cpf || '',
    chave,
    emitidoEm: new Date().toISOString(),
  }
}
